import { IRouteItem } from "../../../../types";
import { IPriceModel } from "../../../../types/Product";
import { PublicProduct } from "../../../../api/publicOrder";

// Helper function to convert string price models to enum
export const convertPriceModels = (models: string[]): IPriceModel[] => {
  return models.map((model) => {
    switch (model) {
      case "Seat":
        return IPriceModel.SEAT;
      case "Fixed":
        return IPriceModel.FIXED;
      case "Volume":
        return IPriceModel.VOLUME;
      case "Weight":
        return IPriceModel.WEIGHT;
      case "Distance":
        return IPriceModel.DISTANCE;
      case "Time":
        return IPriceModel.TIME;
      default:
        return IPriceModel.FIXED;
    }
  });
};

// Helper function to create pricing object from product
export const createPricingObject = (product: PublicProduct) => {
  if (!product.pricing) return undefined;

  return {
    priceModel: convertPriceModels(product.pricing.priceModel || []),
    pricePerSeat: product.pricing.pricePerSeat || 0,
    pricePerCargoUnit: product.pricing.pricePerCargoUnit || 0,
    pricePerDistanceUnit: product.pricing.pricePerDistanceUnit || 0,
    pricePerTimeUnit: product.pricing.pricePerTimeUnit || 0,
    timePeriodInMinutes: product.pricing.timePeriodInMinutes || 0,
    pricePerVolumeUnit: product.pricing.pricePerVolumeUnit || 0,
    pricePerWeightUnit: product.pricing.pricePerWeightUnit || 0,
    vat: product.pricing.vat || 0,
  };
};

// Format addresses for the distance API call
export const formatLocation = (routeItem: IRouteItem) => {
  // If we have coordinates, use them (most accurate)
  if (
    routeItem.location.coordinate?.lat &&
    routeItem.location.coordinate?.lon
  ) {
    return {
      location: {
        latLng: {
          latitude: routeItem.location.coordinate.lat,
          longitude: routeItem.location.coordinate.lon,
        },
      },
    };
  }

  // Otherwise, use address string
  const addressParts = [
    routeItem.location.addressLine,
    routeItem.location.postCode,
    routeItem.location.city,
    routeItem.location.countryCode || "NO",
  ].filter(Boolean);

  return {
    address: addressParts.join(", "),
  };
};
